import React, { useCallback, useEffect, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { useDispatch } from 'react-redux';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { ThesisProgressApi } from '../../../api/thesis-progress/thesis-progress.api';
import { routeName } from '../../../routes/routeName';
import StatusCustom from '../../../components/status/statusCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import { debouncedApiCall } from '../../../utils/app.utils';
import { useMediaQuery, useTheme } from '@mui/material';
import { degreeApi } from '../../../api/degree/degree.api';
import { facultyApi } from '../../../api/factulty/factulty.api';
import { AcademicYearApi } from '../../../api/academic-year/academic-year.api';

export default function EThesisProgress() {
    const navigate: NavigateFunction = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const dispatch = useDispatch();
    const [search, setSearch] = useState<any>('')
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");




    const [degree_data, set_degree_data] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>(null);
    const [search_degree, set_search_degree] = useState<string>("");

    const [faculty_data, set_faculty_data] = useState<any[]>([]);
    const [id_faculty, set_id_faculty] = useState<any>(null);

    const [academic_year_data, set_academic_year_data] = useState<any[]>([]);
    const [id_academic_year, set_id_academic_year] = useState<any>(null);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [

        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("ชื่อ - นามสกุล"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ฉายา"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("รหัสประจำตัวนักศึกษา"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ระดับ"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("หลักสูตร"),
        },
        {
            id: "leave_type_name",
            width: '150px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("ชั้นปีที่"),
        },
        {
            id: "leave_type_name",
            width: '200px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: t("เปอร์เซ็นต์ความคืบหน้า"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: t("สถานะ"),
        },
        {
            id: "action",
            class: matches,
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_student, thesis_progress_percent, thesis_progress_status, student_first_name, student_middle_name, student_last_name, student_nickname, student_no, degree_name, faculty_name, academic_year } =
            objData;

        const objRenderData = {
            key: id_student,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: `${student_first_name} ${student_middle_name || ''} ${student_last_name}`,
                },

                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: student_nickname || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: student_no || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: degree_name || '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: academic_year,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (thesis_progress_percent || 0) + '%' || '0.00',
                },
                {
                    option: "TEXT",
                    align: "center",
                    disablePadding: true,
                    label: thesis_progress_status ? (
                        <StatusCustom
                            sx={{ maxWidth: 200 }}
                            // white_space='nowrap'
                            text={thesis_progress_status === 'APPROVE' ? 'ผ่านการตรวจสอบ' : thesis_progress_status === 'WAITING' ? 'รอพิจารณา' : 'ไม่ผ่านการตรวจสอบ'}
                            type={'มีแจ้งเตือนใหม่'}
                        />
                    ) : '-'
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches,
                    component: (
                        <div className='flex justify-center items-center'>
                            <OptionsButtonCustom
                                enableView
                                onViewClick={() => {
                                    navigate(routeName.cms.ListThesisProgress.replace(':id', id_student), { state: objData })

                                }}

                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };


    const handleGetDegree = useCallback(async () => {
        let query: { search?: string } = {};
        if (search_degree) query.search = search;
        await degreeApi.tree(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                set_degree_data(response);
                console.log(response, 'res')
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [search_degree])

    const handleGetFaculty = useCallback(async (id_degree: number) => {
        let query: { search?: string } = {};
        await facultyApi.listFaculty(id_degree).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                set_faculty_data(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }, [id_degree])
    const handleGetAcademicYear = async () => {
        await AcademicYearApi.getOnlyActiveAcademicYear().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_academic_year_data(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }


    const loadData = useCallback(async () => {
        dispatch(setLoading());
        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (id_degree) condition.id_degree = id_degree?.id_degree;
            if (id_faculty) condition.id_faculty = id_faculty?.id_faculty;
            if (id_academic_year) condition.academic_year = id_academic_year?.id_academic_year;
            const res = await ThesisProgressApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, id_degree, id_faculty, id_academic_year]);

    useEffect(() => {
        loadData();
    }, [loadData]);


    // const handleDelete = async (id: any) => {
    //     await ThesisProgressApi.delete(id).then((res: any) => {
    //         if (res.status < 300) {
    //             swalSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
    //             loadData()
    //         }
    //     }).catch((error: any) => {
    //         console.log(error)
    //         swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
    //     })

    // }
    const handleDownload = async () => {
        let condition: any = {};
        if (page) condition = { ...condition, page: page };
        if (pageLimit) condition = { ...condition, limit: pageLimit };
        if (search) condition = { ...condition, keyword: search };
        if (id_degree) condition.id_degree = id_degree?.id_degree;
        if (id_faculty) condition.id_degree = id_faculty?.id_faculty;
        if (id_academic_year) condition.academic_year = id_academic_year?.id_academic_year;
        await ThesisProgressApi.export(condition).then((res: any) => {
            if (res.status < 300) {
                // window.open(process.env.REACT_APP_FILE_BASE_API + '/' + file?.file_path + file?.file_name, '_blank');
                const blobFile = new Blob([res?.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                const url = URL.createObjectURL(blobFile);
                window.open(url, '_blank');

                console.log(res.data);
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }



    useEffect(() => {
        handleGetAcademicYear();
    }, [])

    useEffect(() => {
        handleGetDegree();
    }, [handleGetDegree])

    useEffect(() => {
        if (id_degree?.id_degree) {
            handleGetFaculty(id_degree?.id_degree);
        }
    }, [handleGetFaculty])


    // function formatBytes(bytes: any, decimals = 2) {
    //     if (!+bytes) return '0 Bytes'

    //     const k = 1024
    //     const dm = decimals < 0 ? 0 : decimals
    //     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    //     const i = Math.floor(Math.log(bytes) / Math.log(k))

    //     return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    // }
    return (
        <div>
            <ContentHeading
                title={t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />

            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 lg:col-span-3 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหา ชื่อ - นามสกุล ฉายา รหัสประจำตัวนักศึกษา")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                            debouncedApiCall({ searchItem: e.target.value, setItem: setSearch })
                        }}
                    />
                </article>
                <article className='col-span-12 lg:col-span-6 sm:col-span-12'>
                    <StateComponents
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12,
                                    lg: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.degree_name || "",
                                    labelId: "EEEE",
                                    onChange: (_, val) => {
                                        set_id_degree(val ?? null);
                                        set_id_faculty(null);
                                    },
                                    placeholder: "ทุกระดับ",
                                    options: degree_data || [],
                                    value: id_degree || null
                                }
                            },
                            {
                                seq: 2,
                                gridProps: {
                                    xs: 12,
                                    lg: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.faculty_name || "",
                                    labelId: "DWAD",
                                    onChange: (_, val) => set_id_faculty(val ?? null),
                                    disabled: !id_degree,
                                    placeholder: "ทุกหลักสูตร",
                                    options: faculty_data || [],
                                    value: id_faculty || null
                                }
                            },
                            {
                                seq: 3,
                                gridProps: {
                                    xs: 12,
                                    lg: 3
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => String(op?.academic_year || ""),
                                    labelId: "DWADSS",
                                    onChange: (_, val) => set_id_academic_year(val ?? null),
                                    placeholder: "ทุกชั้นปี",
                                    options: academic_year_data || [],
                                    value: id_academic_year || null
                                }
                            },
                        ]}
                    />
                </article>
                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            // navigate(routeName.cms.ManageLeaveType + `/create`);
                            // setOpen(true)
                            // setType('CREATE')
                            handleDownload()
                        }}
                        mode="add"
                        buttonName={t("ดาวน์โหลด Excel")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>

        </div>
    )
}
